import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { NgxInviteService } from './invite.service';

export const ngxInviteServiceModule = angular.module('ngxInviteServiceModule', [])
	.factory('ngxInviteService', downgradeInjectable(NgxInviteService) as any)
	.name;
